import * as Yup from 'yup'
import { DateTime } from 'luxon'
import { isValid as isValidCpf } from '@fnando/cpf'
import { isValid as isValidCnpj } from '@fnando/cnpj'

/*
  Campos que a abertura da conta precisa e que não existem no cadastro do titular, mais o
  CPF/CNPJ — que existe no cadastro, mas entra aqui como sugestão editável: é o documento
  digitado que abre a conta no Asaas.

  O restante (nome, telefone, endereço) é lido dos models pela API, que recusa a abertura
  com `missingFields` quando o cadastro está incompleto.
*/
const bankingAccountValidator = Yup.object ().shape ({
  /*
    Os dois só existem para decidir quais campos o formulário exige. Não vão para a API:
    quem manda lá é o documento digitado.
  */
  is_business: Yup.boolean ().default (false),
  use_cnpj: Yup.boolean ().default (true),

  cpfCnpj: Yup.string ()
    .when ('use_cnpj', {
      is: true,
      then: schema => schema
        .required ('Digite o CNPJ')
        .test ('validCnpj', 'Digite um CNPJ válido', value => isValidCnpj (value ?? '')),
      otherwise: schema => schema
        .required ('Digite o CPF')
        .test ('validCpf', 'Digite um CPF válido', value => isValidCpf (value ?? ''))
    }),

  incomeValue: Yup.number ()
    .typeError ('Insira o faturamento mensal')
    .positive ('Insira o faturamento mensal')
    .required ('Insira o faturamento mensal'),

  /*
    Só o CNPJ o exige: no Asaas o tipo de empresa não existe para pessoa física, e o campo
    nem chega a ser mostrado quando o documento é um CPF.
  */
  companyType: Yup.object ()
    .nullable ()
    .when ('use_cnpj', {
      is: true,
      then: schema => schema.required ('Selecione o tipo de empresa')
    }),

  /*
    O oposto do tipo de empresa: o Asaas exige a data de nascimento em toda conta de pessoa
    física, e é só o salão que precisa digitá-la — o estabelecimento não a tem no cadastro,
    enquanto a do profissional já está lá e a API a lê de lá.
  */
  birthDate: Yup.string ()
    .when (['is_business', 'use_cnpj'], {
      is: (isBusiness, useCnpj) => isBusiness && !useCnpj,
      then: schema => schema
        .required ('Digite a data de nascimento')
        .test ('validBirthDate', 'Digite uma data válida (dd/mm/aaaa)', value =>
          DateTime.fromFormat (value ?? '', 'ddMMyyyy').isValid
        )
    })
})

export default bankingAccountValidator
